import {fetchGet, generateEndpoint} from "../../../utils/request";

export const getBsrsSurveys= async(token) => {
  const url = `${generateEndpoint('getBsrsSurveys')}`
  return fetchGet(url, token)
}
